import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { taskCatalogQueryKey } from '../queries/useTaskCatalog'
import { scheduledTasksQueryKey } from '../queries/useScheduledTasks'

export function useDeleteScheduledTask() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('cron')

  async function remove(id: number) {
    await apiClient.delete(`${BACK_OFFICE_PREFIX}scheduled-tasks/${id}`)
  }

  return useMutation({
    mutationFn: remove,
    onSuccess: () => {
      toast.success({ message: t('toast.deleted') })
      queryClient.invalidateQueries({ queryKey: scheduledTasksQueryKey })
      queryClient.invalidateQueries({ queryKey: taskCatalogQueryKey })
    },
    onError
  })
}
